export default {
  bind(el, binding) {
    if (binding.value === false) return

    const computedStyle = getComputedStyle(el)
    const originalColor = computedStyle.color
    const originalBackgroundColor = computedStyle.backgroundColor

    el.addEventListener('mouseenter', () => {
      el.style.color = 'var(--tripla-text-color)'
      el.style.backgroundColor = 'var(--tripla-theme-color)'
    })

    el.addEventListener('mouseleave', () => {
      el.style.color = originalColor
      el.style.backgroundColor = originalBackgroundColor
    })
  }
}
